import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr', 'de', 'it'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [
        HttpBackend, // First backend (Override)
        HttpBackend  // Second backend (Standard)
      ],
      backendOptions: [
        { // Options for the first backend
          loadPath: '/locales/override/{{lng}}/translation.json',
        },
        { // Options for the second backend
          loadPath: '/locales/{{lng}}/translation.json',
        }
      ],
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
